import { useRequest } from 'ahooks';
import { Form, Select } from 'antd';
import LocaleContext from 'locales';
import React, { useContext } from 'react';
import { getVdCreationTemplates } from 'services/websocket/approval';

/**
 * 컴포넌트: VD 그룹 선택 폼
 * @param {boolean} isUserApproval 결재선 옵션이 사용자 결재인가?
 * @param {boolean} isCreate 생성인가?
 * @returns ReactNode
 */
export default function FormItemSelectVdGroup(props) {
  const { isCreate, form } = props;
  const { locale } = useContext(LocaleContext);

  // hooks
  const fetchVdCreationTemplates = useRequest(getVdCreationTemplates); // VD 생성 템플리(=VD 그룹) 조회

  return (
    <>
      <Form.Item
        label={locale.resource['vd-group.sheet.col.group-name']}
        name="vdGroupId"
        required
        rules={[{ required: true, message: locale.resource['txt.required-field'] }]}
      >
        <Select
          loading={fetchVdCreationTemplates.loading}
          allowClear
          style={{ width: 300 }}
          disabled={!isCreate}
          onSelect={(v) => {
            const selectedVdGroup = fetchVdCreationTemplates.data.find((el) => el.vdGroupId === v);
            form.setFieldsValue({
              vdGroupName: selectedVdGroup.name,
              contents: [
                { disk: selectedVdGroup.masterImageSize, flavorName: selectedVdGroup.flavorName },
              ],
            });
          }}
          options={
            !fetchVdCreationTemplates.loading &&
            fetchVdCreationTemplates.data.map((el) => ({
              label: el.name,
              value: el.vdGroupId,
            }))
          }
        />
      </Form.Item>
      <Form.Item name="vdGroupName" hidden />
    </>
  );
}
